export const APIEndpoints = {
    // Auth APIs
    login: '/login',
    register: '/signup',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',

    //profile APIs
    getProfile: '/profile',

    // Upload APIs
    getSubjects: '/get-student-subjects',
    // uploadEssay: '/grade',
    uploadEssay: '/grade',
    // Get Submissions
    getSubmissions: '/my-submissions',

    // upload modal answer:

    // Results APIs
    getResults: '/results',
    getResultDetails:(id) => `/admin/submissions/${id}/ai-results`,


    // past paper APIs
    getPastPapers: '/past-model-answers',

    // Payment APIs
    getPaymentHistory: '/payments/history',
    getActivePackage: '/payments/active-package',
    getPlans: '/subscriptions/plans',
    createCheckoutSession: '/essay-purchases/create-checkout-session',
    getMySubscription: '/subscriptions/my-subscription',
    getMyTransactions: '/subscriptions/my-transactions',
    getMyPurchases: '/essay-purchases/purchases',
};